<i18n>
{
  "fr": {
    "printBtn": "Voir mon fichier d'impression",
    "either": "soit",
    "unit": "/ unité"
  }
}
</i18n>

<template>
  <div class="order-items-confirmation">
    <Swiper :options="swiperOption" class="order-items-confirmation__swiper">
      <SwiperSlide
        v-for="item in items"
        :key="item.name"
        :class="[
          'order-items-confirmation__card',
          {
            'order-items-confirmation__card--center': items.length === 1,
          },
        ]"
      >
        <img
          v-if="item.thumbnailUrl"
          class="order-items-confirmation__image"
          :src="item.thumbnailUrl"
          alt="image produit"
        />
        <div
          :class="[
            'order-items-confirmation__content',
            {
              'order-items-confirmation__content--with-image':
                item.thumbnailUrl,
            },
          ]"
        >
          <span class="order-items-confirmation__title">{{ item.name }}</span>

          <a
            :href="item.customerPressProofUrl"
            target="_blank"
            class="order-items-confirmation__print"
          >
            <i
              class="icon icon--zendesk-chat order-items-confirmation__print-icon"
            ></i>
            <span class="order-items-confirmation__print-label">
              {{ $t('printBtn') }}
            </span>
          </a>

          <div class="order-items-confirmation__save">
            <CreateCustomerProjectButton
              v-if="isAuthenticated"
              :account-url="accountUrl"
              :api-url="item.createProjectUrl"
              auth-url=""
              :customer-project-id="item.customerProjectId"
              :is-authenticated="isAuthenticated"
            />
          </div>

          <div class="order-items-confirmation__prices">
            <span class="order-items-confirmation__total">
              {{ item.total }}
            </span>
            <span v-if="item.quantity" class="order-items-confirmation__label">
              {{ $t('either') }} {{ item.unitaryPrice }} {{ $t('unit') }}
            </span>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
    <div
      v-if="items.length > 1"
      slot="button-next"
      class="order-items-confirmation__swiper-button order-items-confirmation__swiper-button--left"
    >
      <i class="icon icon--arrow-left"></i>
    </div>
    <div
      v-if="items.length > 1"
      slot="button-prev"
      class="order-items-confirmation__swiper-button order-items-confirmation__swiper-button--right"
    >
      <i class="icon icon--arrow-right"></i>
    </div>
    <div
      v-if="items.length > 1"
      class="order-items-confirmation__swiper-border order-items-confirmation__swiper-border--left"
    ></div>
    <div
      v-if="items.length > 1"
      class="order-items-confirmation__swiper-border order-items-confirmation__swiper-border--right"
    ></div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import CreateCustomerProjectButton from './CreateCustomerProjectButton.vue';

export default {
  name: 'OrderItemsConfirmation',
  components: {
    CreateCustomerProjectButton,
    Swiper,
    SwiperSlide,
  },
  props: {
    accountUrl: {
      type: String,
      required: true,
    },
    isAuthenticated: Boolean,
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isSaved: false,
      isSaving: false,
    };
  },
  computed: {
    /**
     * @returns {Object}
     */
    multiProductOption() {
      return this.items.length > 1
        ? {
            slidesPerView: 1.045,
            spaceBetween: 10,
            navigation: {
              nextEl: `.order-items-confirmation__swiper-button--right`,
              prevEl: `.order-items-confirmation__swiper-button--left`,
            },
          }
        : {
            slidesPerView: 1,
          };
    },
    swiperOption() {
      return {
        observer: true,
        observeParents: true,
        keyboard: true,
        breakpoints: {
          800: {
            slidesPerView: 1.7,
          },
        },
        ...this.multiProductOption,
      };
    },
  },
};
</script>
